import * as types from '../types.js';
import db from '../../versa/db.js';
import { parse } from '../../versa/misc.js';
import endpointFunctionGroups from '../config/endpoint-function-groups.js';

export default {

	html: `
		<style>
			#group-form-wrapper { min-width: 52rem; max-width: 90vw; }
			#group #id { width: 20rem; }
			#group #name { width: 20rem; }
			#group .endpoints-section { display: flex; gap: var(--space-md); align-items: flex-start; margin-bottom: var(--space-md); }
			#group .endpoints-keymap { flex: 1; display: flex; gap: var(--space-sm); align-items: stretch; }
			#group .endpoints-keymap .keymap:not(:has(button)) { min-width: 14rem; }
			#group .endpoints-keymap select { min-height: 12rem; }
			#group .endpoint-search { margin-bottom: var(--space-sm); }
			#group .endpoint-search input { width: 100%; max-width: 24rem; }
			#group .function-groups { display: flex; flex-wrap: wrap; gap: var(--space-xs); margin-bottom: var(--space-md); }
			#group .function-groups button { font-size: 0.85em; padding: 0.25rem 0.5rem; }
			#group .function-groups-title { font-size: 0.9em; color: var(--color-muted); margin-bottom: 0.25rem; }
			#group .keymap-transfer { display: flex; flex-direction: column; gap: 0.25rem; justify-content: center; }
			#group .keymap-transfer button { min-width: 2.25rem; min-height: 2rem; font-size: 1.1rem; font-weight: bold; padding: 0.25rem; }
		</style>
		<div id="group-form-wrapper">
		<form id="group" class="form" autocomplete="off">
			<div class="fsb">
				<label title="Identificador do grupo">Grupo
					<input id="id" type="text" disabled>
				</label>
				<label title="Nome do grupo">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
			</div>
			<div class="endpoints-section">
				<div>
					<div class="function-groups-title">Por função (adicionar todos de uma vez)</div>
					<div class="function-groups" id="function-groups"></div>
					<div class="endpoint-search">
						<label>Buscar endpoints
							<input id="endpoint_search" type="text" placeholder="Digite para filtrar...">
						</label>
					</div>
					<div class="fsb endpoints-keymap">
						<label class="keymap">Endpoints<sup>*</sup>
							<select id="endpoints" multiple size="8" required>
							</select>
						</label>
						<span class="keymap keymap-transfer">
							<button class="bn_Left" title="Incluir endpoints selecionados">&#8592; Incluir</button>
							<button class="bn_Right" title="Remover endpoints selecionados">Remover &#8594;</button>
						</span>
						<label class="keymap">Disponíveis
							<select id="available_endpoints" multiple size="8">
							</select>
						</label>
					</div>
				</div>
			</div>
			<div class="fsb">
				<label class="keymap">Empresas<sup>*</sup>
					<select id="companies" multiple size="6" required>
					</select>
				</label>
				<span class="keymap keymap-transfer">
					<button class="bn_Left" title="Incluir empresas">&#8592; Incluir</button>
					<button class="bn_Right" title="Remover empresas">Remover &#8594;</button>
				</span>
				<label class="keymap">Disponíveis
					<select id="available_companies" multiple size="6">
					</select>
				</label>
			</div>
			<div class="fsb mtm">
				<span></span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
		</div>
	`,

	form: {
		selector: '#group',
		init(formset) {
			Object.getPrototypeOf(this).init.call(this);
			const form = formset.form;
			const root = formset.dialog?.getNode?.();
			if (!root) return;
			const searchInput = root.querySelector('#endpoint_search');
			const availableSelect = root.querySelector('#available_endpoints');
			const leftBtn = root.querySelector('.bn_Left');
			const fnGroupsEl = root.querySelector('#function-groups');
			endpointFunctionGroups.forEach(fg => {
				const btn = document.createElement('button');
				btn.type = 'button';
				btn.className = 'button';
				btn.textContent = fg.label;
				btn.title = `Adicionar todos os endpoints de ${fg.label}`;
				btn.addEventListener('click', async () => {
					const all = await db.list('endpoints') || [];
					const selected = form.getFieldBySelector('#endpoints')?.getValue?.() || [];
					const selectedSet = new Set(selected.map(String));
					const matches = all.filter(ep => {
						const path = (ep.endpoint || '').toLowerCase();
						return fg.patterns.some(p => path.includes(p.toLowerCase())) && !selectedSet.has(String(ep.id));
					});
					if (matches.length === 0) return;
					const matchIds = new Set(matches.map(m => String(m.id)));
					Array.from(availableSelect.options).forEach(opt => {
						const parsed = parse(opt.value);
						const optId = Array.isArray(parsed) ? parsed[0] : parsed;
						if (matchIds.has(String(optId))) opt.selected = true;
					});
					leftBtn?.click();
				});
				fnGroupsEl?.appendChild(btn);
			});
			searchInput?.addEventListener('input', () => {
				const q = (searchInput.value || '').toLowerCase().trim();
				Array.from(availableSelect.options).forEach(opt => {
					opt.style.display = !q || opt.textContent.toLowerCase().includes(q) ? '' : 'none';
				});
			});
		},
	},

	fields: [
		{ properties: { selector: '#id' }, types: [] },
		{ properties: { selector: '#name' }, types: [types.name()] },
		{ properties: { selector: '#endpoints' }, types: [types.keymap('endpoints', '#available_endpoints', { labels: ['name', 'method'] }), types.km_fill()] },
		{ properties: { selector: '#companies' }, types: [types.keymap('all_companies', '#available_companies', { labels: ['nick'] }), types.km_fill()] },
	]

};

